export default __webpack_public_path__ + "static/media/elementos-end-to-end-solutions.81ef0bb9.svg";